// data/products.js
export const productCategories = [
  "전자제품",
  "가전제품", 
  "사무용품",
  "소프트웨어",
  "서비스",
  "기타"
];

export const products = [
  // 전자제품
  { id: 1, name: "노트북", category: "전자제품", unitPrice: 1200000, unit: "대", description: "업무용 노트북" },
  { id: 2, name: "모니터", category: "전자제품", unitPrice: 300000, unit: "대", description: "24인치 LED 모니터" },
  { id: 3, name: "키보드", category: "전자제품", unitPrice: 80000, unit: "개", description: "기계식 키보드" },
  { id: 4, name: "마우스", category: "전자제품", unitPrice: 50000, unit: "개", description: "무선 마우스" },
  { id: 5, name: "스마트폰", category: "전자제품", unitPrice: 900000, unit: "대", description: "안드로이드 스마트폰" },

  // 가전제품
  { id: 6, name: "냉장고", category: "가전제품", unitPrice: 800000, unit: "대", description: "양문형 냉장고" },
  { id: 7, name: "세탁기", category: "가전제품", unitPrice: 600000, unit: "대", description: "드럼세탁기" },
  { id: 8, name: "에어컨", category: "가전제품", unitPrice: 1000000, unit: "대", description: "벽걸이 에어컨" },
  { id: 9, name: "전자레인지", category: "가전제품", unitPrice: 200000, unit: "대", description: "전자레인지" },

  // 사무용품
  { id: 10, name: "복사용지", category: "사무용품", unitPrice: 5000, unit: "권", description: "A4 복사용지" },
  { id: 11, name: "펜", category: "사무용품", unitPrice: 1000, unit: "자루", description: "볼펜" },
  { id: 12, name: "노트", category: "사무용품", unitPrice: 3000, unit: "권", description: "스프링 노트" },
  { id: 13, name: "파일", category: "사무용품", unitPrice: 2000, unit: "개", description: "클리어파일" },
  { id: 14, name: "책상", category: "사무용품", unitPrice: 150000, unit: "개", description: "사무용 책상" },
  { id: 15, name: "의자", category: "사무용품", unitPrice: 120000, unit: "개", description: "사무용 의자" },

  // 소프트웨어
  { id: 16, name: "윈도우 라이선스", category: "소프트웨어", unitPrice: 200000, unit: "개", description: "Windows 10 Pro" },
  { id: 17, name: "오피스 라이선스", category: "소프트웨어", unitPrice: 150000, unit: "개", description: "Microsoft Office" },
  { id: 18, name: "포토샵 라이선스", category: "소프트웨어", unitPrice: 300000, unit: "개", description: "Adobe Photoshop" },
  { id: 19, name: "백신 프로그램", category: "소프트웨어", unitPrice: 50000, unit: "개", description: "안티바이러스" },

  // 서비스
  { id: 20, name: "웹사이트 개발", category: "서비스", unitPrice: 2000000, unit: "건", description: "반응형 웹사이트 개발" },
  { id: 21, name: "모바일 앱 개발", category: "서비스", unitPrice: 3000000, unit: "건", description: "안드로이드/iOS 앱" },
  { id: 22, name: "시스템 유지보수", category: "서비스", unitPrice: 500000, unit: "월", description: "월 유지보수 서비스" },
  { id: 23, name: "데이터베이스 설계", category: "서비스", unitPrice: 1000000, unit: "건", description: "DB 설계 및 구축" },
  { id: 24, name: "교육 서비스", category: "서비스", unitPrice: 100000, unit: "시간", description: "IT 교육 서비스" }
];

// 제품 검색 함수
export const searchProducts = (query) => {
  if (!query) return products;
  return products.filter(product => 
    product.name.toLowerCase().includes(query.toLowerCase()) ||
    product.description.toLowerCase().includes(query.toLowerCase())
  );
};

// 카테고리별 제품 필터링
export const getProductsByCategory = (category) => {
  if (!category || category === "전체") return products;
  return products.filter(product => product.category === category);
};

// 최근 사용 제품 관리
export const getRecentProducts = () => {
  const recent = localStorage.getItem('recentProducts');
  return recent ? JSON.parse(recent) : [];
};

export const addToRecentProducts = (product) => {
  let recent = getRecentProducts();
  
  // 중복 제거
  recent = recent.filter(p => p.id !== product.id);
  
  // 맨 앞에 추가
  recent.unshift(product);
  
  // 최대 10개까지만 저장
  if (recent.length > 10) {
    recent = recent.slice(0, 10);
  }
  
  localStorage.setItem('recentProducts', JSON.stringify(recent));
};

// 새 제품 추가
export const addProduct = (productData) => {
  const newId = Math.max(...products.map(p => p.id)) + 1;
  const newProduct = { id: newId, ...productData };
  products.push(newProduct);
  return newProduct;
};

// 제품 수정
export const updateProduct = (productId, productData) => {
  const index = products.findIndex(p => p.id === productId);
  if (index !== -1) {
    products[index] = { ...products[index], ...productData };
    return products[index];
  }
  return null;
};

// 제품 삭제
export const deleteProduct = (productId) => {
  const index = products.findIndex(p => p.id === productId);
  if (index !== -1) {
    const deleted = products.splice(index, 1);
    return deleted[0];
  }
  return null;
};